import React from 'react';
import PropTypes from 'prop-types';
import TooltipedIconButton from './Base/TooltipedIconButton';

function LockedButton({ onClick, id, text }) {
  return (
    <TooltipedIconButton
      text={text}
      onClick={onClick}
      id={id}
      className="btn btn-outline-warning"
      icon="fa fa-lock"
    />
  );
}

LockedButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default LockedButton;
